/**
 * Itens da LC 116/2003 em que a obra precisa de matrícula (CNO) e a retenção
 * previdenciária costuma incidir. Fonte da regra de triagem, não de apuração.
 */
export const ITENS_CONSTRUCAO_CIVIL = [
    '7.02', // execução de obra por empreitada ou subempreitada
    '7.04', // demolição
    '7.05', // reparação, conservação e reforma de edifícios
    '7.15', // escoramento, contenção de encostas
    '7.16', // limpeza e drenagem
    '7.17', // acompanhamento e fiscalização de obra
    '7.19', // acompanhamento e fiscalização de execução
];
export function isConstrucaoCivil(item) {
    return ITENS_CONSTRUCAO_CIVIL.includes(item);
}
/** CST/CSOSN de operação com ICMS efetivamente tributado. */
export const CST_ICMS_TRIBUTADO = ['00', '10', '20', '51', '70', '90', '201', '202', '900'];
/**
 * Normaliza o código do serviço para o formato "7.02".
 * Aceita "070200" (cTribNac), "0702" (ItemListaServico), "702" e "7.02".
 */
export function normalizarItemServico(codigo) {
    const s = (codigo ?? '').trim();
    if (s === '')
        return '';
    if (s.includes('.')) {
        const [head, tail = ''] = s.split('.');
        const a = Number.parseInt(head ?? '', 10);
        if (!Number.isFinite(a))
            return s;
        const b = tail.replace(/\D/g, '').slice(0, 2).padStart(2, '0');
        return `${a}.${b}`;
    }
    let dg = s.replace(/\D/g, '');
    if (dg === '')
        return s;
    if (dg.length >= 4)
        dg = dg.slice(0, 4);
    else if (dg.length === 3)
        dg = `0${dg}`;
    else
        return s;
    return `${Number.parseInt(dg.slice(0, 2), 10)}.${dg.slice(2, 4)}`;
}
/** CNO tem 12 dígitos, exibido como 99.999.99999/99. */
export function formatarCno(digitos) {
    const d = digitos.replace(/\D/g, '');
    if (d.length !== 12)
        return digitos;
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 10)}/${d.slice(10)}`;
}
export function formatarDocumento(doc) {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14)
        return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
    if (d.length === 11)
        return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    return d;
}
/** Normaliza para 14 posições maiúsculas, sem pontuação. */
export function normalizarCnpj(cnpj) {
    return (cnpj ?? '').toUpperCase().replace(/[^0-9A-Z]/g, '');
}
/**
 * Valida o dígito verificador do CNPJ. Desde 2026 as 12 primeiras posições
 * podem ter letras, e o cálculo passou a usar o valor ASCII menos 48 no lugar
 * do dígito. Para o CNPJ só numérico de sempre isso dá exatamente o mesmo
 * resultado ('0'.charCodeAt(0) - 48 === 0), então uma rotina só atende os dois
 * formatos — não é preciso ramificar.
 */
export function cnpjValido(cnpj) {
    const c = normalizarCnpj(cnpj);
    if (c.length !== 14)
        return false;
    // Os dois dígitos verificadores continuam numéricos mesmo no alfanumérico.
    if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(c))
        return false;
    // Repetição pura (00000000000000) fecha o cálculo e nunca é CNPJ real.
    if (/^(.)\1{13}$/.test(c))
        return false;
    const valor = (ch) => ch.charCodeAt(0) - 48;
    const dv = (ate) => {
        let peso = 2;
        let soma = 0;
        for (let i = ate - 1; i >= 0; i--) {
            soma += valor(c[i]) * peso;
            peso = peso === 9 ? 2 : peso + 1;
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };
    return dv(12) === Number(c[12]) && dv(13) === Number(c[13]);
}
//# sourceMappingURL=servicos.js.map